module.exports = __webpack_public_path__ + "static/media/swamp.e42867e4.png";